module.exports = __webpack_public_path__ + "img/img56.82ea3fe4.svg";